import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LabelSystem from '@labels/systems/ReduxLabelSystem';

import LabelsGroupsModalPresenter, { type LabelGroupType } from './LabelsGroupsModalPresenter';
import WorkspaceSystem from '../../systems/WorkspaceSystem';
import useAutoupdatePresenterProperty from '../../hooks/useAutoupdatePresenterProperty';
import { getProject } from '../../selectors/projects';
import { getWorkspaceLabelGroups } from '../../selectors/labelGroups';

export { type LabelGroupType };

const useLabelsGroupsModalPresenter = ( projectID: number, labelGroupType: LabelGroupType ) => {
	const dispatch = useDispatch();
	const workspaceSystem: WorkspaceSystem = new WorkspaceSystem( dispatch );
	const labelSystem: LabelSystem = new LabelSystem( dispatch );

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const project = useSelector( state => getProject( state, { projectID } ) );

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const labelGroupsState = useSelector( state => getWorkspaceLabelGroups( state, {
		workspaceID: project.workspaceID
	} ) );

	const labelGroups = useMemo( () => {
		if ( labelGroupType === 'Workspace' ) {
			return labelGroupsState?.workspace_label_groups || [];
		}
		return labelGroupsState?.project_label_groups || [];
	}, [ labelGroupsState, labelGroupType ] );

	const createPresenter = () => new LabelsGroupsModalPresenter( {
		project,
		labelGroupType,
		labelGroups,
		labelSystem,
		workspaceSystem
	} );

	const [ presenter ] = useState( createPresenter );

	useAutoupdatePresenterProperty( { presenter, name: 'project', value: project } );
	useAutoupdatePresenterProperty( { presenter, name: 'labelGroups', value: labelGroups } );

	return presenter;
};

export default useLabelsGroupsModalPresenter;
